// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/requestDetail.scss
 ** module id = 25
 ** module chunks = 0
 **/